import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import * as React from 'react';
import {classify} from 'src/utils/classify';

import {Smallest} from 'src/designSystem2021Components/text-v2';

import css from './textarea.css';


export type Props = {
  value?: string;
  onChange?: (
    evt: React.ChangeEvent<HTMLInputElement>,
    isEnter?: boolean,
  ) => unknown;
  onFocus?: (e: React.ChangeEvent<HTMLInputElement>) => unknown;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => unknown;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => unknown;
  name?: string;
  disabled?: boolean;
  placeholder?: string;
  error?: boolean;
  errorText?: string;
  label?: string | React.ReactNode;
  contextLabel?: string | React.ReactNode;
  boxClassName?: string;
  rows?: string;
  bottomBar?: React.ReactNode;
};

const Textarea_ = (
  props: Props &
    Omit<
      Omit<
        // @ts-expect-error TS2552
        React.HTMLProps<HTMLTextareaElement>,
        | 'ref'
        | 'disabled'
        | 'name'
        | 'placeholder'
        | 'value'
        | 'onChange'
        | 'onFocus'
        | 'onBlur'
      >,
      keyof Props
    >,
  ref:
    | ((arg1: null | HTMLTextAreaElement) => unknown)
    | {
        current: null | HTMLTextAreaElement;
      },
) => {
  const {
    value,
    onChange,
    onFocus,
    onBlur,
    name,
    disabled,
    placeholder,
    error,
    errorText,
    label,
    contextLabel,
    boxClassName,
    bottomBar,
    ...textareaProps
  } = props;

  const controlledTextareaFilled = value !== '';

  return (
    <div
      className={classify(css.wrapper, {
        [css.filled]: controlledTextareaFilled ?? false,
        [css.withError]: error ?? false,
      })}
    >
      {(Boolean(label) || Boolean(contextLabel)) && (
        <div className={css.info}>
          <Smallest className={css.commonLabel}>{label ?? ''}</Smallest>
          <Smallest className={css.commonLabel}>
            {error && errorText ? errorText : contextLabel ?? ''}
          </Smallest>
        </div>
      )}
      <div
        className={classify(css.box, boxClassName, {
          [css.textareaDisabled]: disabled ?? false,
        })}
      >
        <textarea
          // @ts-expect-error - TS2322 - Type '{ current: HTMLTextAreaElement | null; } | ((arg1: HTMLTextAreaElement | null) => unknown)' is not assignable to type 'Ref<HTMLTextAreaElement> | undefined'.
          ref={ref}
          disabled={disabled}
          name={name}
          placeholder={placeholder}
          value={value}
          // @ts-expect-error - TS2322 - Type '((evt: ChangeEvent<HTMLInputElement>, isEnter?: boolean | undefined) => unknown) | undefined' is not assignable to type 'ChangeEventHandler<HTMLTextAreaElement> | undefined'.
          onChange={onChange}
          // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLInputElement>) => unknown) | undefined' is not assignable to type 'FocusEventHandler<HTMLTextAreaElement> | undefined'.
          onFocus={onFocus}
          // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLInputElement>) => unknown) | undefined' is not assignable to type 'FocusEventHandler<HTMLTextAreaElement> | undefined'.
          onBlur={onBlur}
          {...textareaProps}
        ></textarea>
        {bottomBar}
      </div>
    </div>
  );
};

// @ts-expect-error - TS2352 - Conversion of type 'ForwardRefExoticComponent<HTMLTextAreaElement & RefAttributes<Props>>' to type 'AbstractComponent<Props, HTMLTextAreaElement>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
export const Textarea = React.forwardRef<Props, HTMLTextAreaElement>(
  // @ts-expect-error - TS2345 - Argument of type '(props: Props & Omit<Omit<React.HTMLProps<HTMLTextareaElement>, "ref" | "disabled" | "name" | "placeholder" | "value" | "onChange" | "onFocus" | "onBlur">, keyof Props>, ref: ((arg1: null | HTMLTextAreaElement) => unknown) | { current: null | HTMLTextAreaElement; }) => React.JSX.Element' is not assignable to parameter of type 'ForwardRefRenderFunction<Props, HTMLTextAreaElement>'.
  Textarea_,
) as Flow_AbstractComponent<Props, HTMLTextAreaElement>;
